<template>
    <div class="root">
      <div class="content">
        <NavigationBar/>
        <h3 class="content_title">Apparel</h3>
        <ProductsGrid :products="getApparelData" v-if="getApparelData && !getIsApparelDataLoading"/>
        <div class="spinner-grow" role="status" v-else>
        </div>
        </div>
        <FooterView class="footer_align"/>
    </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar.vue';
import ProductsGrid from '../components/ProductsGrid.vue';
import FooterView from '../components/Footer.vue'
export default {
  name: 'ApparelScreen',
  components: {
    NavigationBar,
    ProductsGrid,
    FooterView
  },
  data(){
    return {
    itemsInCart:0,
    }
  },
  methods:{
    incrementCount(){
        this.$store.dispatch('increment')
    },
    decreaseCount(){
        this.itemsInCart--
    }
  },
  computed:{
    getApparelData(){
      return this.$store.state.apparelProducts  
    },
    getIsApparelDataLoading(){
      return this.$store.state.isApparelProductsLoading
    }
  },
  async mounted() {
    this.$store.dispatch('getApparel')
  }
  
}
</script>

<style scoped>
.content_title{
    margin: 25px;
}
.root{
  display: flex;
  flex-direction: column;
  height: 100%; /* or 100vh if it's the viewport */
}
.content{
  flex: 1; /* takes all available space */
}
.footer_align{

}
</style>